import { isInboxItem } from '@seen/core/models/inbox'
import { useCallback } from 'react'
import { toast } from 'sonner'
import type { InboxNotificationItemFilterFn } from '#src/hooks/inbox/filter.ts'
import { useKnockFeedClient } from '#src/hooks/useKnockFeedClient.ts'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

/* Reads the Knock feed snapshot at call time rather than subscribing —
   see useMarkRelatedInboxItemsAsDone for rationale. */
export function useMarkRelatedInboxItemsAsRead(options?: {
  silent?: boolean
}): (filterFn: InboxNotificationItemFilterFn) => void {
  const feedClient = useKnockFeedClient()
  return useCallback(
    (filterFn: InboxNotificationItemFilterFn) => {
      const { items } = feedClient.store.getState()
      const itemsToMarkAsRead = items.filter(
        (item): item is NotificationItem =>
          !item.read_at &&
          isInboxItem(item.data) &&
          filterFn(item as NotificationItem)
      )
      if (itemsToMarkAsRead.length) {
        void feedClient.markAsRead(itemsToMarkAsRead)
        if (!options?.silent) {
          toast.success(
            itemsToMarkAsRead.length > 1
              ? `${itemsToMarkAsRead.length} matching inbox items marked as read`
              : 'Matching inbox item marked as read'
          )
        }
      }
    },
    [feedClient, options?.silent]
  )
}
